import React from 'react';

import { orderURL, thirdPartyTransferDetailsURL } from '@admin/config/routes';
import { LongDistanceMoveFragment } from '@admin/schema';

export const LongDistanceMoveSummary: React.FC<{
  move: LongDistanceMoveFragment;
}> = ({ move }) => {
  const { account, pickup, transfer, delivery } = move;

  return (
    <ul className="list-unstyled">
      <li>
        <strong>Long-Distance Move</strong>
        <ul className="list-unstyled" style={{ marginLeft: '1rem' }}>
          <li>
            <strong>Pickup:</strong>{' '}
            <a
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              href={orderURL({ id: pickup.id, account: account })}
            >
              #{pickup.number}
            </a>
          </li>

          <li>
            <strong>Transfer:</strong>{' '}
            {transfer ? (
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                href={thirdPartyTransferDetailsURL(account.id, transfer.id)}
              >
                {`${transfer.bookingPlatform} | ${transfer.bookingNumber}`}
              </a>
            ) : (
              <>None Scheduled</>
            )}
          </li>

          <li>
            <strong>Delivery:</strong>{' '}
            {delivery ? (
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                href={orderURL({ id: delivery.id, account: account })}
              >
                #{delivery.number}
              </a>
            ) : (
              <>None Scheduled</>
            )}
          </li>
        </ul>
      </li>
    </ul>
  );
};
